import localStorageService from "../services/localStorage.service";

/**
 * Access checks for features that are gated in the UI.
 *
 * This is a visibility gate, not a security boundary: the underlying endpoints
 * are already company-scoped by `check_permission`. Keep in sync with
 * `backend/app/feature_access.py`.
 */

// Tag Diagnostics is released to all clients, so every logged-in user has access.
export const canAccessTagDiagnostics = () => {
  try {
    return Boolean(localStorageService.getUserData());
  } catch (error) {
    // Unreadable storage means not logged in, never a crash.
    return false;
  }
};
